import React from "react";
import FallBackImg from "../../FallBackImg/fallBackImg";
import PropTypes from "prop-types";

const FeaturedImage = ({
  imgSrc,
  postTitle,
  postFeaturedImg,
  fallBackImgCustomClassName,
  fallBackImg,
  fallBackImgMobile,
  fallBackImgAlt,
}) => {
  return postFeaturedImg ? (
    <FallBackImg
      fallbackImg={imgSrc}
      fallbackImgAlt={postTitle}
      customClassName={fallBackImgCustomClassName}
    />
  ) : (
    <FallBackImg
      fallbackImg={fallBackImg}
      fallbackImgMobile={fallBackImgMobile}
      fallbackImgAlt={fallBackImgAlt}
      customClassName={fallBackImgCustomClassName}
    />
  );
};

FeaturedImage.propTypes = {
  imgSrc: PropTypes.string,
  postTitle: PropTypes.string,
  postFeaturedImg: PropTypes.object,
  fallBackImgCustomClassName: PropTypes.string,
  fallBackImg: PropTypes.string,
  fallBackImgMobile: PropTypes.string,
  fallBackImgAlt: PropTypes.string,
};

export default FeaturedImage;
